export const ACTIVITY_MESSAGE_FILTERS = {
  adclicked: {
    label: 'label.AD_CLICKED',
    value: 'adclicked',
    enabled: false
  },
  attachment: {
    label: 'label.ATTACHMENT',
    value: 'attachment',
    enabled: false
  },
  attachmentviewed: {
    label: 'label.ATTACHMENT_VIEWED',
    value: 'attachmentviewed',
    enabled: false
  },
  attachmentdownloaded: {
    label: 'label.ATTACHMENT_DOWNLOADED',
    value: 'attachmentdownloaded',
    enabled: false
  },
  attachmentreplay: {
    label: 'label.ATTACHMENT_REPLAY',
    value: 'attachmentreplay',
    enabled: false
  },
  linkclick: {
    label: 'label.LINK_CLICK',
    value: 'linkclick',
    enabled: false
  },
  website: {
    label: 'label.WEBSITE_VISITED',
    value: 'website',
    enabled: false
  },
  bizcardview: {
    label: 'label.BIZCARD_VIEW',
    value: 'bizcardview',
    enabled: false
  },
  bizcardscan: {
    label: 'label.BIZCARD_SCAN',
    value: 'bizcardscan',
    enabled: false
  }
  // video: {
  //   label: 'Video',
  //   value: 'video',
  //   enabled: false
  // }
};
